import {useTranslation} from "react-i18next";

const useHelpUrl = () => {
  const {i18n} = useTranslation("common");

  return `${i18n.resolvedLanguage === "ger" ? "/help/" : `/${i18n.resolvedLanguage}/help/`}`;
};

export {useHelpUrl};
